import { GTreeNode } from "./GTreeNode";
import { TreeSelection } from "./selection/TreeSelection";
import { WidgetPool } from "./WidgetPool";
import { LayoutType, SelectionMode } from "./Const";
import { GPanel } from "./GPanel";
import { SerializeUtil } from "../loaders/SerializeUtil";
import { LayaEnv } from "../../LayaEnv";
import { GButton } from "./GButton";
export class GTree extends GPanel {
    constructor() {
        super(null, TreeSelection);
        this.scrollToViewOnExpand = false;
        this.indent = 15;
        this.layout.type = LayoutType.SingleColumn;
        this.selection.mode = SelectionMode.Single;
        this._pool = new WidgetPool();
        this.rootNode = new GTreeNode(true);
        this.rootNode._setTree(this);
        this.rootNode.expanded = true;
    }
    get selection() {
        return this._selection;
    }
    get clickToExpand() {
        return this._selection.clickToExpand;
    }
    set clickToExpand(value) {
        this._selection.clickToExpand = value;
    }
    get itemTemplate() {
        return this._pool.defaultRes;
    }
    set itemTemplate(value) {
        this._pool.defaultRes = value;
    }
    get itemPool() {
        return this._pool;
    }
    expandAll(folderNode) {
        if (!folderNode)
            folderNode = this.rootNode;
        folderNode.expanded = true;
        let cnt = folderNode.numChildren;
        for (let i = 0; i < cnt; i++) {
            let node = folderNode.getChildAt(i);
            if (node.isFolder)
                this.expandAll(node);
        }
    }
    collapseAll(folderNode) {
        if (!folderNode)
            folderNode = this.rootNode;
        if (folderNode != this.rootNode)
            folderNode.expanded = false;
        let cnt = folderNode.numChildren;
        for (let i = 0; i < cnt; i++) {
            let node = folderNode.getChildAt(i);
            if (node.isFolder)
                this.collapseAll(node);
        }
    }
    createCell(node) {
        node.createCell();
        if (this.treeNodeRender)
            this.treeNodeRender(node, node.cell);
    }
    _afterInserted(node) {
        if (!node.cell)
            this.createCell(node);
        let index = this.getInsertIndexForNode(node);
        this.addChildAt(node.cell, index);
        if (this.treeNodeRender)
            this.treeNodeRender(node, node.cell);
        if (node.isFolder && node.expanded)
            this.checkChildren(node, index);
    }
    getInsertIndexForNode(node) {
        let prevNode = node.getPrevSibling();
        if (prevNode == null)
            prevNode = node.parent;
        let insertIndex = this.getChildIndex(prevNode.cell) + 1;
        let myLevel = node.level;
        let cnt = this.numChildren;
        for (let i = insertIndex; i < cnt; i++) {
            let testNode = this.getChildAt(i).treeNode;
            if (testNode && testNode.level <= myLevel)
                break;
            insertIndex++;
        }
        return insertIndex;
    }
    _afterRemoved(node) {
        this.removeNode(node);
    }
    _afterExpanded(node, byEvent) {
        if (node == this.rootNode) {
            this.checkChildren(this.rootNode, 0);
            return;
        }
        if (this.treeNodeWillExpand)
            this.treeNodeWillExpand(node, true);
        if (node.onExpanded)
            node.onExpanded(true);
        if (node.cell == null)
            return;
        if (this.treeNodeRender)
            this.treeNodeRender(node, node.cell);
        if (node.cell.parent) {
            this.checkChildren(node, this.getChildIndex(node.cell));
            if (this.scrollToViewOnExpand && this.scroller != null) {
                let scrollTo = node.getLastVisibleDecendant();
                if (scrollTo == null && node.cell.visible)
                    scrollTo = node;
                if (scrollTo)
                    this.scroller.scrollTo(scrollTo.cell, false, node.cell);
            }
        }
    }
    _afterCollapsed(node, byEvent) {
        if (node == this.rootNode) {
            this.checkChildren(this.rootNode, 0);
            return;
        }
        if (this.treeNodeWillExpand)
            this.treeNodeWillExpand(node, false);
        if (node.onExpanded)
            node.onExpanded(false);
        if (node.cell == null)
            return;
        if (this.treeNodeRender)
            this.treeNodeRender(node, node.cell);
        if (node.cell.parent)
            this.hideFolderNode(node);
    }
    _afterMoved(node) {
        let startIndex = this.getChildIndex(node.cell);
        let endIndex;
        if (node.isFolder)
            endIndex = this.getFolderEndIndex(startIndex, node.level);
        else
            endIndex = startIndex + 1;
        let insertIndex = this.getInsertIndexForNode(node);
        if (startIndex == insertIndex || startIndex == insertIndex - 1)
            return;
        let cnt = endIndex - startIndex;
        if (insertIndex < startIndex) {
            for (let i = 0; i < cnt; i++) {
                let obj = this.getChildAt(startIndex + i);
                this._setChildIndex(obj, startIndex + i, insertIndex + i);
            }
        }
        else {
            for (let i = 0; i < cnt; i++) {
                let obj = this.getChildAt(startIndex);
                this._setChildIndex(obj, startIndex, insertIndex - 1);
            }
        }
    }
    getFolderEndIndex(startIndex, level) {
        let cnt = this.numChildren;
        for (let i = startIndex + 1; i < cnt; i++) {
            let node = this.getChildAt(i).treeNode;
            if (node.level <= level)
                return i;
        }
        return cnt;
    }
    checkChildren(folderNode, index) {
        let cnt = folderNode.numChildren;
        for (let i = 0; i < cnt; i++) {
            index++;
            let node = folderNode.getChildAt(i);
            if (node.cell == null)
                this.createCell(node);
            if (!node.cell.parent)
                this.addChildAt(node.cell, index);
            if (node.isFolder && node.expanded)
                index = this.checkChildren(node, index);
        }
        return index;
    }
    hideFolderNode(folderNode) {
        let cnt = folderNode.numChildren;
        for (let i = 0; i < cnt; i++) {
            let node = folderNode.getChildAt(i);
            if (node.cell)
                this.removeChild(node.cell);
            if (node.isFolder && node.expanded)
                this.hideFolderNode(node);
        }
    }
    removeNode(node) {
        if (node.cell) {
            node.cell.removeSelf();
            if (node._cellFromPool) {
                this._pool.recover(node.cell);
                node.cell = null;
            }
        }
        if (node.isFolder) {
            let cnt = node.numChildren;
            for (let i = 0; i < cnt; i++) {
                let node2 = node.getChildAt(i);
                this.removeNode(node2);
            }
        }
    }
    onAfterDeserialize() {
        super.onAfterDeserialize();
        if (SerializeUtil.hasProp("_initItemNum", "_itemData") && (LayaEnv.isPreview || !SerializeUtil._data._isDemo))
            this._buildInitItems();
    }
    _buildInitItems() {
        var _a, _b;
        this.rootNode.removeChildren();
        if (this.itemTemplate == null)
            return;
        let itemData = this._itemData;
        let prevLevel = 0;
        let lastNode;
        for (let i = 0; i < this._initItemNum; i++) {
            let m = (itemData && i < itemData.length) ? itemData[i] : null;
            if (m != null) {
                let level = m.level || 0;
                let isFolder = (((_a = itemData[i + 1]) === null || _a === void 0 ? void 0 : _a.level) || 0) > level;
                let node = new GTreeNode(isFolder, (_b = m.res) === null || _b === void 0 ? void 0 : _b.url);
                node.expanded = true;
                if (i == 0)
                    this.rootNode.addChild(node);
                else {
                    if (level > prevLevel)
                        lastNode.addChild(node);
                    else if (level < prevLevel) {
                        for (let j = level; j <= prevLevel; j++)
                            lastNode = lastNode.parent;
                        lastNode.addChild(node);
                    }
                    else
                        lastNode.parent.addChild(node);
                }
                lastNode = node;
                prevLevel = level;
                let child = node.cell;
                child.text = m.title;
                if (m.icon)
                    child.icon = m.icon;
                if (child instanceof GButton) {
                    if (m.selectedTitle)
                        child.selectedTitle = m.selectedTitle;
                    if (m.selectedIcon)
                        child.selectedIcon = m.selectedIcon;
                    child.selected = false;
                }
                if (m.name != null)
                    child.name = m.name;
            }
            else {
                let node = new GTreeNode();
                this.rootNode.addChild(node);
                prevLevel = 0;
                lastNode = node;
            }
        }
        this.selection._refresh();
    }
}
